// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZP6NK","main":"styles_main__MO84Q","featured":"styles_featured__g510_"};